import { useQuery, useQueryClient } from "@tanstack/react-query"
import { getDocumentoComercialPendienteFirmar } from "./DocumentoComercial.service"

export function useDocumentoComercialPendienteFirmar() {
  const queryClient = useQueryClient()
  const {
    data: documentoComercialData,
    error: documentoComercialError,
    isLoading: documentoComercialIsLoading,
    refetch: documentoComercialRefetch,
  } = useQuery({
    queryKey: ["documentoComercialPendienteFirmar"],
    queryFn: getDocumentoComercialPendienteFirmar,
    refetchOnWindowFocus: false,
    retry: false,
    retryOnMount: false,
  })

  const documentoComercialInvalidation = () =>
    queryClient.invalidateQueries({ queryKey: ["documentoComercial"] })

  return {
    documentoComercialData,
    documentoComercialError,
    documentoComercialIsLoading,
    documentoComercialRefetch,
    documentoComercialInvalidation,
  }
}
